import { Controller } from 'stimulus'

class HeaderController extends Controller {
  clickBurger () {
    this.element.classList.toggle('burger--active')
    $('.menu').toggleClass('menu--active')
    $('body').toggleClass('no-scroll has-menu')
  }
}

export default HeaderController
